import styled from 'styled-components';
import {basicColor, boxShadow, font, radius} from '../../../../styles/template';



const TestingSelect = styled.div`
	width: 100%;
	& .Select__control {
		min-height: 7rem;
		border: none;
		box-shadow: ${boxShadow.small};
		background: ${basicColor.white};
        ${font.basicBoldS};
		color: ${basicColor.deepDark};
		border-radius: ${radius.normal};
		padding-left: 2rem;
		z-index: 2;
		width: 100%;
	    display: grid;
	    grid-template-rows: auto;
	    gap: 0;
	    grid-template-columns: 1fr auto;
	    align-items: center;
	}
	
	
	& .Select__control:hover {
		cursor: pointer;
	}
	
	& .Select__control--menu-is-open:hover {
		cursor: text;
	}
	
	& .Select__menu {
		position: relative;
		background: ${basicColor.white};
		box-shadow:  8px 14px 21px rgba(0, 0, 0, 0.10);
		top: -2rem;
		margin-bottom: 0;
		color: ${basicColor.deepDark};
		padding: 1rem 0 0;
	}
	
	& .Select__menu-list {
		border-radius: 0 0 ${radius.normal} ${radius.normal};
	}
	
	& .Select__placeholder, & .Select__input, & .Select__single-value {
		color: ${basicColor.deepDark};
	}

	& .Select__control--menu-is-open .Select__placeholder,
	& .Select__control--menu-is-open .Select__input {
		color: ${({ theme }) => theme.color.MidtoneItem};
	}
	
	& .Select__control--menu-is-open {
		background: ${basicColor.white};
	}
	
	& .Select__control:hover {
		border: none;
	}
	
	& .Select__option {
		${font.basicS};
		background: none;
		color: ${basicColor.deepDark};
		cursor: pointer;
		padding: 2rem;	
	}
	
	
	& .Select__menu-list--is-multi .Select__option {
		padding: 1rem 3rem;
	}
	
	& .Select__option--is-selected,
	& .Select__option:active {
		background: ${basicColor.faintGray};
	}
	
	& .Select__indicator-separator {
		display: none;
	}
	
	& .Select__indicator,
	& .Select__indicator:hover {
		color: ${basicColor.deepDark};
	}
	
	& .Select__multi-value {
		background:  ${basicColor.primary};
		border-radius: 2rem;
		padding: 0 1rem;
		min-width: auto;
		align-items: center;
		cursor: default;
	}
	
	& .Select__control--menu-is-open .Select__multi-value {
		background:  ${({ theme }) => theme.color.Overlay};
	}
	
	& .Select__multi-value__label {
		color: ${basicColor.white};
	}
	
	& .Select__value-container {
	    padding: 0;
		flex-wrap: nowrap;
		overflow-x: auto;
	}
	
	& .Select__value-container::-webkit-scrollbar {
      height: 0;
    }
    
	& .Select__multi-value__remove {
	    color: ${basicColor.white};
	    border-radius: 100%;
	    width: 2rem;
	    height: 2rem;
	    padding: 2px;
	    cursor: pointer;
	}
	
	& .Select__multi-value__remove:hover {
		background-color: ${basicColor.primary};
		color: ${basicColor.white};
	}
	
	& .Select__option--is-disabled {
		text-decoration: line-through;
	}
	
	& .Select__menu-notice {
		padding: 2rem 2rem 0;
		color:  ${basicColor.deepDark};
		${font.basicS};
	}
	
	& .Select--is-disabled {
		opacity: 0.6;
	}

`;

export default TestingSelect